export default "__VITE_ASSET__DleL5huJ__"